<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center ">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-10 color-bg-login min-h-login">
              <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
              <img src="@/assets/images/pages/sms.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">

              <div class="p-8 login-tabs-container py-login">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Verificación de teléfono</h4>
                  <p>Agregaremos una capa más de seguridad a tu cuenta, introduce tu número de teléfono y enviaremos un mensaje de texto con un código de activación.</p>
                </div>

                <div>

                  <vue-tel-input enabledCountryCode placeholder="Teléfono" @input="onInput"></vue-tel-input>

                  <br>
                  <vs-button class="float-right" :disabled="isSubmitted" @click="submitSmsVerification">Siguiente</vs-button>
                  <vs-button :to="{name: 'page-login'}" type="flat">Cerrar sesión</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {VueTelInput} from 'vue-tel-input'

export default {
  name: "Sms-Verification",
  props: ['toggleTab', 'setPhone'],
  components: {
    VueTelInput
  },
  data() {
    return {
      phone: null,
      isSubmitted: false
    }
  },
  computed: {
    ...mapState('account', ['status']),
  },
  methods: {
    ...mapActions('account', ['smsVerification']),
    onInput(formattedNumber, { number, valid, country }) {
      this.phone = number.international;
    },
    submitSmsVerification() {
      const {phone} = this;
      if (phone) {
        this.isSubmitted = true;
        this.smsVerification({phone: phone.replace(/\s+/g, '')})
         .then(
           () => {
             this.setPhone(this.phone);
             this.toggleTab(2);
             this.isSubmitted = false;
           }
         )
        .catch(() => this.isSubmitted = false);
      } else {
        this.$vs.notify({title:'Error',text:"Ingrese los datos requeridos y verifica que el teléfono contenga 10 dígitos", color: 'danger', position:'bottom-center'})
      }
    }
  }
}
</script>

<style scoped>

</style>
